import { Trans, useTranslation } from 'react-i18next';
import tKey from '../../../Common/Utils/tKey';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';
import ProductSEO from '../../_Sections/ProductSEO';
import SectionBranding from '../../_Sections/SectionBranding';
import SectionDetails from '../../_Sections/SectionDetails';
import SectionDropship from '../../_Sections/SectionDropship';
import SectionGallery from '../../_Sections/SectionGallery';
import SectionPairings from '../../_Sections/SectionPairings';
import SectionPricing from '../../_Sections/SectionPricing';
import SectionSizes from '../../_Sections/SectionSizes';

const PRODUCT_ID = 8;
const VIEW_PRODUCT_ID = 74;

export default function PolyCanvasPillowCasePage() {
  const [t] = useTranslation('page/products/poly-canvas-pillow-cases');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom all-over print Poly Canvas Pillow Cases | Products')}
      description={t('Custom printed poly canvas pillow cases are the perfect way to add a modern touch to your living space. Durable and digitally printed for long lasting comfort, this hand-sewn pillow case is printed on demand and made to order in Montreal, Canada.')}
    />

    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#ffa1d8"
      bgStyle={{
        backgroundPosition: 'center right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '48%',
      }}
      fullPageBg
      tag={t('The all-over print')}
      title={t('Poly Canvas Pillow Cases')}
      text={t('Give your living space a modern upgrade with the custom printed poly canvas pillow cases, the perfect blend of durable and chic!')}
      createUrl={productData.get('url_slug')}
      img={require('@resources/img/pages/products/poly-canvas-pillow/banner-1.png')}
      alt={t('Picture of a girl with a custom printed Poly Canvas Pillow Case')}
      details={[
        {
          img: require('@resources/img/pages/products/poly-canvas-pillow/icon-1.svg?url'),
          alt: t('Fabric icon'),
          text: t('50 000 double rub count 100% polyester canvas is durable with a sleek, modern texture'),
        },
        {
          img: require('@resources/img/pages/products/poly-canvas-pillow/icon-2.svg?url'),
          alt: t('Sizes icon'),
          text: t('Available in 5 square and rectangular size options'),
        },
        {
          img: require('@resources/img/pages/products/poly-canvas-pillow/icon-3.svg?url'),
          alt: t('Zipper icon'),
          text: t('Finished with invisible zipper closure in black or white'),
        },
        {
          img: require('@resources/img/pages/products/poly-canvas-pillow/icon-4.svg?url'),
          alt: t('Ink icon'),
          text: t('Digital, all-over prints are permanent, vibrant and printed on demand'),
        },
        {
          img: require('@resources/img/pages/products/poly-canvas-pillow/icon-5.svg?url'),
          alt: t('Hand-sewn icon'),
          text: t('Hand-sewn and made to order in Montreal, Canada'),
        },
      ]}
    />

    <SectionGallery images={[
      require('@resources/img/pages/products/poly-canvas-pillow/gallery_0.jpg'),
      require('@resources/img/pages/products/poly-canvas-pillow/gallery_1.jpg'),
      require('@resources/img/pages/products/poly-canvas-pillow/gallery_2.jpg'),
      require('@resources/img/pages/products/poly-canvas-pillow/gallery_3.jpg'),
      require('@resources/img/pages/products/poly-canvas-pillow/gallery_4.jpg'),
    ]} />

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your Poly Canvas Pillow Cases <br/> <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('Your brand and following will love Poly Canvas Pillow Cases! At prices designed for reselling, Poly Canvas Pillow Cases made on demand meet the needs of sellers who prefer not to stock inventory. Sell them in your eCommerce store and decide your profit margin')}
    />

    <SectionPricing
      productId={PRODUCT_ID}
      variants={['22x22','20x14','24x12','26x20']}
      optionFilters={{
        fabric: ['canvas'],
        color: ['white', 'black', 'designed'],
      }}
      listOptions
    />

    <SectionSizes
      productId={PRODUCT_ID}
      title={t('Pillow Case Sizing')}
      text={t('Poly canvas pillowcases come in 5 diverse sizes to fit any space - 3 rectangular and 2 square.')}
    >
      <img
        src={require('@resources/img/pages/products/poly-canvas-pillow/measurement.svg?url')}
        style={{
          marginRight: 0,
        }}
      />
    </SectionSizes>

    <SectionBranding
      title={t('Brand your Poly Canvas Pillow Cases')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
      hasLabel
    />

    <SectionPairings
      text={t('Pair your Poly Canvas Pillow Cases with these great products to create your own unique styles.')}
      productSlugs={['duvet-covers', 'blanket', 'tapestries']}
    />
  </div>
}
